import * as React from 'react';
import { Redirect, Route, Switch } from 'react-router';
import { EditSchoolSettings } from 'Src/views/GenericView/AdminView/AdminConsole/SchoolSettings/EditSchoolSettings/EditSchoolSettings';
import { PublicSiteSettings } from 'Src/views/GenericView/AdminView/AdminConsole/SchoolSettings/PublicSiteSettings/PublicSiteSettings';
import { WebsiteWidgets } from 'Src/views/GenericView/AdminView/AdminConsole/SchoolSettings/WebsiteWidgets/WebsiteWidgets';
import { BigScreenSettings } from 'Src/views/GenericView/AdminView/AdminConsole/SchoolSettings/BigScreenSettings/BigScreenSettings';
import { UnionTournamentCommunicationsSettings } from './UnionTournamentCommunicationsSettings';

export const UnionSettingsRouting = allProps => (
  <Switch>
    <Route
      exact
      path="/union/settings/tournament-communications"
      render={() => (
        <UnionTournamentCommunicationsSettings user={allProps.user} onSchoolUpdate={allProps.onSchoolUpdate} />
      )}
    />
    <Route
      exact
      path="/union/settings/general"
      render={props => <EditSchoolSettings {...props} user={allProps.user} onSchoolUpdate={allProps.onSchoolUpdate} />}
    />
    <Route
      exact
      path="/union/settings/public-site"
      render={props => <PublicSiteSettings {...props} user={allProps.user} onSchoolUpdate={allProps.onSchoolUpdate} />}
    />
    <Route exact path="/union/settings/website-widgets" render={() => <WebsiteWidgets user={allProps.user} />} />
    <Route
      exact
      path="/union/settings/big-screen"
      render={props => <BigScreenSettings {...props} user={allProps.user} onSchoolUpdate={allProps.onSchoolUpdate} />}
    />
    <Redirect to="/union/settings/general" />
  </Switch>
);

UnionSettingsRouting.displayName = 'UnionSettingsRouting';
